import type { ReactNode } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import LoyaltyBenefitIcon from 'loyalty/components/LoyaltyBenefitIcon'

const Row = styled.div`
  display: grid;
  grid-template-columns: ${rem(24)} minmax(0, 1fr) auto;
  align-items: center;
  gap: ${rem(12)};
`

const IconArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.palette.neutral.surface.normalContrast};
`

/** Label + optional inline status, wrapping on narrow widths (matches the Figma row). */
const Content = styled.div`
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${rem(4)};
`

interface Props {
  benefitType: App.LoyaltyBenefitType
  heading: ReactNode
  /** Optional emphasis line shown inline after the heading (e.g. eSIM activation note). */
  status?: ReactNode
  /** The CTA (e.g. a "View" / "Add to booking" AssistChip). */
  action: ReactNode
}

/**
 * Compact, icon-led benefit row used by the "upcoming escapes" benefits card.
 * Reuses the order-view benefit behaviour but with a lightweight presentation
 * (no image thumbnail) — distinct from the large `LoyaltyBenefitItemTile`.
 */
function LoyaltyBenefitCompactRow({ benefitType, heading, status, action }: Props) {
  return <Row>
    <IconArea>
      <LoyaltyBenefitIcon benefitType={benefitType} size="M" />
    </IconArea>
    <Content>
      <BodyText variant="medium">{heading}</BodyText>
      {!!status && status}
    </Content>
    {action}
  </Row>
}

export default LoyaltyBenefitCompactRow
